import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { useConfigSlice } from '../../../store/slices/config/selectors';
import { popupActions } from '../../../store/slices/popup/slice';
import { PopupType } from '../../popup/types';
import { NickNameEditFormConnected } from '../../settings/nickName/NickNameEditFormConnected';

import { BlockingModalContent } from './BlockingModalContent';

import styles from './popupContent.module.css';

export const NicknameEnterConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();

  const showNicknameDisclaimer = useConfigSlice.casinoConfig()?.showNicknameDisclaimer;

  const onNickNameSave = (): void => {
    dispatch(popupActions.dismissPopup(PopupType.NicknameEnter));
  };

  const messageContent = (
    <>
      <NickNameEditFormConnected inPopUp onNickNameSave={onNickNameSave} />

      {showNicknameDisclaimer ? (
        <div className={styles.popupContent__disclaimer}>
          <L10nText tk="PERSONAL_DATA" />
        </div>
      ) : null}
    </>
  );

  return <BlockingModalContent titleTk="SETTINGS_CHOOSE_NICKNAME" messageComponent={messageContent} />;
};
